export const SHOPPING_CART_ADD_PRODUCT = 'SHOPPING_CART_ADD_PRODUCT';
export const SHOPPING_CART_REMOVE_PRODUCT = 'SHOPPING_CART_REMOVE_PRODUCT';
export const SHOPPING_CART_UPDATE_QUANTITY = 'SHOPPING_CART_UPDATE_QUANTITY';
export const SHOPPING_CART_EMPTY = 'SHOPPING_CART_EMPTY';
export const SHOPPING_CART_ADD_QUICK_PURCHASE = 'SHOPPING_CART_ADD_QUICK_PURCHASE';
export const SHOPPING_CART_REMOVE_QUICK_PURCHASE = 'SHOPPING_CART_REMOVE_QUICK_PURCHASE';
